/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  ImportBlankProductsMutationRequest,
  ImportBlankProductsMutationResponse,
} from "../types/ImportBlankProducts.ts"

export const importBlankProductsMutationKey = () =>
  [{ url: "/v1/product/import-blank-products" }] as const

export type ImportBlankProductsMutationKey = ReturnType<
  typeof importBlankProductsMutationKey
>

/**
 * @summary Import blank products
 * {@link /v1/product/import-blank-products}
 */
export async function importBlankProducts(
  data: ImportBlankProductsMutationRequest,
  config: Partial<RequestConfig<ImportBlankProductsMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ImportBlankProductsMutationResponse,
    ResponseErrorConfig<Error>,
    ImportBlankProductsMutationRequest
  >({
    method: "POST",
    url: `/v1/product/import-blank-products`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function importBlankProductsMutationOptions(
  config: Partial<RequestConfig<ImportBlankProductsMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = importBlankProductsMutationKey()
  return mutationOptions<
    ResponseConfig<ImportBlankProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ImportBlankProductsMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return importBlankProducts(data, config)
    },
  })
}

/**
 * @summary Import blank products
 * {@link /v1/product/import-blank-products}
 */
export function useImportBlankProducts<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ImportBlankProductsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: ImportBlankProductsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<ImportBlankProductsMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? importBlankProductsMutationKey()

  const baseOptions = importBlankProductsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ImportBlankProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ImportBlankProductsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<ImportBlankProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ImportBlankProductsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ImportBlankProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ImportBlankProductsMutationRequest },
    TContext
  >
}
